<template>
  <nav class="bottom-navigation">
    <div class="nav-items">
      <router-link to="/" class="nav-item" :class="{ active: $route.path === '/' }">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
          <path d="M4 10.5L12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-7H10v7H5a1 1 0 0 1-1-1v-9.5z"/>
        </svg>
        {{ $t('bottomNav.首页') }}
      </router-link>
      <router-link to="/wealth" class="nav-item" :class="{ active: $route.path.startsWith('/wealth') }">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
          <path d="M12 3c4.5 3.6 6.5 7.2 6.5 10.8A6.5 6.5 0 1 1 5.5 13.8C5.5 10.2 7.5 6.6 12 3z"/>
          <path d="M12 8.5v8"/>
        </svg>
        {{ $t('bottomNav.算力申请') }}
      </router-link>
      <router-link to="/farm" class="nav-item farm-tab" :class="{ active: $route.path === '/farm' }">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
          <path d="M12 3v3M8 6l2 2M16 6l-2 2"/>
          <path d="M6 13c0-3.3 2.7-6 6-6s6 2.7 6 6v6H6v-6z"/>
          <path d="M9 19h6"/>
        </svg>
        {{ $t('bottomNav.农场') }}
      </router-link>
      <router-link to="/assets" class="nav-item" :class="{ active: $route.path === '/assets' }">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
          <circle cx="12" cy="8" r="3.2"/>
          <path d="M5.6 19c1.2-3 3.5-4.5 6.4-4.5s5.2 1.5 6.4 4.5"/>
        </svg>
        {{ $t('bottomNav.资产') }}
      </router-link>
    </div>
  </nav>
</template>

<script>
export default { name: 'BottomNavigation' }
</script>

<style scoped>
.bottom-navigation {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  border-top: 1px solid #b8dce4;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(16px);
  /* 避开刘海/安卓系统导航栏；个别安卓 env 为 0 时用 JS 兜底变量 */
  padding-bottom: var(--app-safe-bottom, env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
}

.nav-items {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  min-height: 58px;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 58px;
  padding: 8px 4px 6px;
  text-decoration: none;
  color: #111827;
  font-size: 11px;
  font-weight: 700;
  font-family: var(--font-ui);
}

.nav-item svg {
  width: 20px;
  height: 20px;
  stroke: #374151;
  flex-shrink: 0;
}

.nav-item.active {
  color: #111827;
  background: #d7eef3;
  box-shadow: inset 0 2px 0 #2eb4d4;
}

.nav-item.active svg {
  stroke: #2eb4d4;
}

.nav-item.farm-tab {
  color: #111827;
}

.nav-item.farm-tab svg {
  stroke: #374151;
}

.nav-item.farm-tab.active {
  color: #111827;
  background: #d7eef3;
  box-shadow: inset 0 2px 0 #2eb4d4;
}

.nav-item.farm-tab.active svg {
  stroke: #2eb4d4;
}

</style>
